import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

// The publication-requirements failure, rendered in full instead of a toast
// that shows only its first sentence. One row per blocker: the REQUIREMENT as
// the heading (what publishing needs), the backend's own message as the
// explanation (why this profile fails it — it names the offending value), and
// a link to the page that fixes it when the field maps to one.
//
// Amber, not red: nothing broke and nothing was lost — the draft is intact and
// still publishable once the profile is completed. Red here would read as a
// failure the supplier can't act on, which is the opposite of the case.
export default function PublicationBlockersPanel({ summary, blockers, className = '' }) {
  if (!blockers?.length) return null;

  return (
    <section
      className={`rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 ${className}`}
      // A publish attempt that just failed is a result the supplier is waiting
      // on, so it is announced rather than left to be noticed.
      role="alert"
    >
      <p className="flex items-start gap-2 text-xs font-semibold text-amber-900 m-0">
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="mt-0.5 shrink-0"
        />
        <span>{summary}</span>
      </p>

      <ul className="list-none p-0 mt-2.5 mb-0 flex flex-col gap-2.5">
        {blockers.map((blocker, index) => (
          <li
            key={blocker.code || blocker.field || index}
            className="pl-5 border-l-2 border-amber-300"
          >
            <p className="text-xs font-semibold text-amber-900 m-0">{blocker.requirement}</p>
            {blocker.message ? (
              // break-words: these messages quote email addresses and domains,
              // which are long unbroken strings that would otherwise overflow
              // the panel on a narrow viewport.
              <p className="text-[11px] leading-snug text-amber-800 m-0 mt-0.5 break-words">
                {blocker.message}
              </p>
            ) : null}
            {blocker.fixTarget ? (
              <Link
                to={blocker.fixTarget.to}
                className="inline-flex items-center gap-1 mt-1 text-[11px] font-semibold text-amber-900 no-underline hover:underline"
              >
                {blocker.fixTarget.label}
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-[9px]"
                />
              </Link>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
}
